import React, { Component } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { SelectBox, Template } from "devextreme-react";
import moment from "moment";
import DateBox from "devextreme-react/date-box";
import { getRequestParams } from "../../helpers/globalfunctions.js";
import { DateFormat } from "../../helpers/fixcodes";
import { LoadPanel } from "devextreme-react/load-panel";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton.js";
import { RadioGroup } from "devextreme-react";
import { LocateVehicleComponent } from "../Shared/LocateVehicleComponent.jsx";
import { ReplayVehicleComponent } from "../Shared/ReplayVehicleComponent.jsx";

const tripStatusTypeList = [
  { id: 0, name: "All Rides" },
  { id: 1, name: "Pending" },
  { id: 2, name: "On Job" },
  { id: 3, name: "Completed" },
  { id: 4, name: "Cancelled" },
];
const DutyTypeLst = [
  { id: 0, name: "All Duty" },
  { id: 1, name: "Fly" },
  { id: 2, name: "Non Fly" },
];
export class DispatchComponent extends Component {
  static displayName = DispatchComponent.name;

  constructor(props) {
    super(props);
    this.state = {
      isFilterSubmitted: false,
      isAirlineRideApiLoading: false,
      loadPanelVisible: false,
      filterFromDatetime: new Date(),
      filterToDatetime: moment(new Date()).format("MM/DD/YYYY") + " 23:59:59",
      filterDropdownAirportDataSource: [],
      airportCode: "",
      tripStatusTypeId: 0,
      tripLst: [],
      tripGridDataSource: [],
      activityTypeId: 0,
      dutyTypeId: 0,
      reservationTitle: "Crew Transfers ",
      locateVehicleMap: {
        openModal: false,
        rideId: 0,
        vehicleNo: "",
      },
      replayVehicleMap: {
        openModal: false,
        rideId: 0,
        vehicleId: 0,
        vehicleNo: "",
        locationTime: "",
        completedTime: "",
      },
    };
    this.refDataGrid = React.createRef();
  }
  componentDidMount() {
    try {
      document.querySelector("#lblPageTitle").innerHTML = `Crew Transfer`;
      this.fetGridDataOnPageLoad();
    } catch (error) {
      console.log(error);
    }
  }
  fetGridDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        await this.getAirports();
      }, 0);
      setTimeout(async () => {
        this.setState((prev) => ({
          ...prev,
          isAirlineRideApiLoading: true,
        }));
        await this.getTrips();
        this.setState((prev) => ({
          ...prev,
          isAirlineRideApiLoading: false,
        }));
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  getAirports = async () => {
    try {
      let apiUrl = `${
        process.env.REACT_APP_API_BASE_URL
      }Airport/get-airport-dropdown/${sessionStorage.getItem(
        "session_airlineCode"
      )}`;
      const res = await fetch(apiUrl, getRequestParams("GET")).then(
        (response) => response.json()
      );
      this.setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: res.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAirports function",
        err
      );
    }
  };
  getTrips = async () => {
    try {
      var request = {};
      let filterFromDatetime = moment(this.state.filterFromDatetime).startOf(
        "day"
      );
      let filterToDatetime = moment(this.state.filterToDatetime).endOf("day");
      request.AirlineCode = sessionStorage.getItem("session_airlineCode");
      request.StatusId = this.state.tripStatusTypeId;
      request.FromDate =
        moment(filterFromDatetime).format(`YYYY-MM-DD HH:mm:ss`);
      request.ToDate = moment(filterToDatetime).format(`YYYY-MM-DD HH:mm:ss`);
      request.AirportCode = this.state.airportCode;
      const requestParams = getRequestParams("POST", request);
      this.setState((prev) => ({
        ...prev,
        filterFromDatetime: filterFromDatetime,
        filterToDatetime: filterToDatetime,
      }));
      let url = process.env.REACT_APP_API_BASE_URL + "Rides/get-rides";
      const response = await fetch(url, requestParams);
      const data = await response.json().then((res) => res.payload);
      let tripLst = data?.filter((f) => f.tripStatusId !== 118) ?? [];
      // tripLst = [
      //   ...new Set(
      //     tripLst?.map((item, index) => ({
      //       ...item,
      //       id: index + 1,
      //     }))
      //   ),
      // ];
      this.setState((prev) => ({
        ...prev,
        isAirlineRideApiLoading: false,
        tripLst: tripLst,
      }));
      this.filterTripDataGridDutyTypeWise(this.state.dutyTypeId, tripLst);
    } catch (error) {
      console.log("Error in " + this.displayName + ".getTrips function", error);
    }
  };
  filterTripDataGridDutyTypeWise = (dutyTypeId, tripLst) => {
    try {
      let tripGridDataSource = [
        ...new Set(
          tripLst?.filter(
            (f) =>
              dutyTypeId === 0 ||
              (dutyTypeId === 1 &&
                (f.activityTypeId === 0 || f.activityTypeId === 1)) ||
              (dutyTypeId === 2 && f.activityTypeId === 2)
          )
        ),
      ];
      this.setState((prev) => ({
        ...prev,
        tripGridDataSource: tripGridDataSource,
      }));
    } catch (error) {
      console.log(error);
    }
  };
  render() {
    const renderGridCell = (data) => {
      let showReplay =
        data.data.tripStatusId === 116 &&
        data.data.locationTime &&
        data.data.completedTime &&
        data.data.vehicleId;
      let locateVehicle = data.data.isOnJob && (
        <a
          title="Locate Vehicle"
          onClick={(e) => {
            e.preventDefault();
            try {
              this.setState((prev) => ({
                ...prev,
                locateVehicleMap: {
                  openModal: true,
                  rideId: data.data.rideId,
                  vehicleNo: data.data.vehicleNo,
                },
              }));
            } catch (error) {
              console.log(error);
            }
          }}
        >
          <i
            style={{ cursor: "pointer" }}
            className="fas fa-map-marker-alt fa-lg btn-link"
          />
        </a>
      );
      let replayVehicle = showReplay && (
        <a
          title="Replay Vehicle"
          onClick={(e) => {
            e.preventDefault();
            try {
              this.setState((prev) => ({
                ...prev,
                replayVehicleMap: {
                  openModal: true,
                  rideId: data.data.rideId,
                  vehicleId: data.data.vehicleId,
                  vehicleNo: data.data.vehicleNo,
                  locationTime: data.data.locationTime,
                  completedTime: data.data.completedTime,
                },
              }));
            } catch (error) {
              console.log(error);
            }
          }}
        >
          <i
            style={{
              cursor: "pointer",
              marginLeft: `${locateVehicle ? "8px" : "3px"}`,
            }}
            className="fas fa-play-circle fa-lg btn-link"
          />
        </a>
      );

      return (
        <div style={{ textAlign: "left" }}>
          {locateVehicle}
          {replayVehicle}
        </div>
      );
    };
    return (
      <>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-2 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>From Date</label>
                  <DateBox
                    type="date"
                    className="replay-date-time"
                    name="filterFromDatetime"
                    placeholder="MM/dd/yyyy"
                    displayFormat="MM/dd/yyyy"
                    showAnalogClock={true}
                    useMaskBehavior={true}
                    defaultValue={this.state.filterFromDatetime}
                    value={this.state.filterFromDatetime}
                    onValueChanged={(e) => {
                      this.setState((prev) => ({
                        ...prev,
                        filterFromDatetime: e.value,
                      }));
                    }}
                    width="100%"
                    disabled={false}
                    acceptCustomValue={false}
                  />
                </div>
              </div>
              <div className="col-lg-2 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>To Date</label>
                  <DateBox
                    type="date"
                    className="replay-date-time"
                    name="filterToDatetime"
                    placeholder="MM/dd/yyyy"
                    displayFormat="MM/dd/yyyy"
                    showAnalogClock={true}
                    useMaskBehavior={true}
                    defaultValue={this.state.filterToDatetime}
                    value={this.state.filterToDatetime}
                    onValueChanged={(e) => {
                      this.setState((prev) => ({
                        ...prev,
                        filterToDatetime: e.value,
                      }));
                    }}
                    width="100%"
                    disabled={false}
                    acceptCustomValue={false}
                  />
                </div>
              </div>
              <div className="col-lg-2 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>Airport(s)</label>
                  <SelectBox
                    dataSource={this.state.filterDropdownAirportDataSource}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="All Airports"
                    value={this.state.airportCode}
                    displayExpr="airportName"
                    valueExpr="airportCode"
                    showClearButton={true}
                    searchEnabled={true}
                    onValueChanged={(e) => {
                      this.setState((prev) => ({
                        ...prev,
                        airportCode: e.value ?? "",
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div className="form-group">
                  <span className="form-check form-group">
                    <RadioGroup
                      dataSource={tripStatusTypeList}
                      valueExpr="id"
                      displayExpr="name"
                      layout="horizontal"
                      defaultValue={this.state.tripStatusTypeId}
                      onValueChanged={(e) => {
                        this.setState((prev) => ({
                          ...prev,
                          tripStatusTypeId: e.value ?? 0,
                        }));
                      }}
                    />
                  </span>
                </div>
              </div>
              <div className="col-lg-2 col-md-12 col-sm-12">
                <div className="form-group">
                  <br />
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={async () => {
                      try {
                        this.setState((prev) => ({
                          ...prev,
                          isFilterSubmitted: true,
                          isAirlineRideApiLoading: true,
                        }));
                        await this.getTrips();
                        this.setState((prev) => ({
                          ...prev,
                          isFilterSubmitted: false,
                          isAirlineRideApiLoading: false,
                        }));
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <span title="Search">
                      <i
                        className={`fas fa-${
                          this.state.isFilterSubmitted
                            ? "spinner fa-spin"
                            : "search"
                        }`}
                      ></i>
                      &nbsp;Search
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            {this.state.isAirlineRideApiLoading && (
              <DataGridSkeletonPageSimpleWithTitle />
            )}
            {!this.state.isAirlineRideApiLoading && (
              <DataGrid
                ref={this.refDataGrid}
                dataSource={this.state.tripGridDataSource}
                columnAutoWidth={true}
                showColumnLines={true}
                showRowLines={true}
                showBorders={true}
                rowAlternationEnabled={false}
                allowColumnResizing={true}
                onRowPrepared={(e) => {
                  if (e.rowType === "header") {
                    e.rowElement.style.backgroundColor = "#f0f2f5";
                  }
                  if (e.rowType === "data") {
                    if (e.data.tripStatusId === 101) {
                      e.rowElement.style.backgroundColor = "#ffffff";
                      if (e.data.activityTypeId === 2) {
                        e.rowElement.style.backgroundColor = "#f2f2f2";
                      }
                    } else if (e.data.tripStatusId === 111) {
                      e.rowElement.style.backgroundColor = "#f2f2f2";
                      e.rowElement.style.foregroundColor = "#ffffff";
                    } else if (e.data.tripStatusId === 104) {
                      e.rowElement.style.backgroundColor = "#FFFB77";
                    } else if (e.data.tripStatusId === 103) {
                      e.rowElement.style.backgroundColor = "#f2f2f2";
                    } else if (e.data.tripStatusId === 105) {
                      e.rowElement.style.backgroundColor = "#f2f2f2";
                    } else if (e.data.tripStatusId === 107) {
                      e.rowElement.style.backgroundColor = "#FFFF01";
                    } else if (e.data.tripStatusId === 108) {
                      e.rowElement.style.backgroundColor = "#D4FFD4";
                    } else if (e.data.tripStatusId === 109) {
                      e.rowElement.style.backgroundColor = "#eabdf5";
                      e.rowElement.style.foregroundColor = "#ffffff";
                    } else if (e.data.tripStatusId === 110) {
                      e.rowElement.style.backgroundColor = "#eabdf5";
                      e.rowElement.style.foregroundColor = "#ffffff";
                    } else if (e.data.tripStatusId === 116) {
                      e.rowElement.style.backgroundColor = "#01B050";
                      e.rowElement.style.foregroundColor = "#ffffff";
                    }
                  }
                }}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift(
                    {
                      location: "before",
                      template: "toolbarDataFilterTemplate",
                    },
                    {
                      location: "before",
                      template: "toolbarDataDutyTypeDropdownTemplate",
                    },
                    {
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          try {
                            this.refDataGrid.current.instance.beginCustomLoading();
                            e.component.option(
                              "icon",
                              "fas fa-spinner fa-spin"
                            );
                            await new Promise((resolve) =>
                              setTimeout(resolve, 1000)
                            ); // 0.5 sec
                            await this.getTrips();
                            this.refDataGrid.current.instance.endCustomLoading();
                            e.component.option("icon", "refresh");
                          } catch (error) {
                            console.log(error);
                          }
                        },
                      },
                    }
                  );
                }}
              >
                <Column
                  dataField="rideId"
                  caption=""
                  allowSorting={false}
                  allowSearch={false}
                  allowExporting={false}
                  allowFiltering={false}
                  cellRender={renderGridCell}
                  fixed={true}
                  width={35}
                />
                <Column
                  dataField="rideId"
                  caption="Ride Id #"
                  allowSearch={true}
                  dataType={"string"}
                />
                <Column
                  dataField="activityType"
                  caption="Duty Type"
                  allowFiltering={true}
                />

                <Column
                  dataField="transporterName"
                  caption="Service Provider"
                  allowSearch={true}
                />
                <Column
                  dataField="paxName"
                  caption="Crew Name"
                  allowSearch={true}
                />
                <Column
                  dataField="employeeNo"
                  caption="Employee No"
                  allowSearch={true}
                />
                <Column
                  dataField="paxMobileNo"
                  caption="Crew Mobile"
                  allowSearch={true}
                />
                <Column
                  dataField="activityDisplay"
                  caption="Activity"
                  allowSearch={true}
                  width={150}
                />

                <Column
                  dataField="flightTime"
                  caption="Flight Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="flightTerminal"
                  caption="Terminal"
                  allowSearch={true}
                />
                <Column
                  dataField="flightATA"
                  caption="Flight Actual Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="activityStartTime"
                  caption="Activity Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="crewPosition"
                  caption="Crew Type"
                  allowSearch={true}
                  alignment={"center"}
                />
                <Column
                  dataField="crewRank"
                  caption="Rank"
                  allowSearch={true}
                  alignment={"center"}
                />
                <Column
                  dataField="pickupTime"
                  caption="Pickup Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="dutyReportingTime"
                  caption="Reporting Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="deBriefingTime"
                  caption="DeBriefing Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />

                <Column
                  dataField="pickupLocation"
                  caption="Pickup"
                  allowSearch={true}
                  width={200}
                />
                <Column
                  dataField="dropoffLocation"
                  caption="Dropoff"
                  allowSearch={true}
                  width={200}
                />

                <Column
                  dataField="vehicleNo"
                  caption="Vehicle"
                  allowSearch={true}
                />
                <Column
                  dataField="driverName"
                  caption="Driver"
                  allowSearch={true}
                />
                <Column
                  dataField="tripStatus"
                  caption="Ride Status"
                  allowSearch={true}
                />
                <Column
                  dataField="assignedStatus"
                  caption="Assigned Status"
                  allowSearch={true}
                />
                <Column
                  dataField="boardingOtp"
                  caption="Boarding Otp"
                  allowSearch={true}
                  dataType={"string"}
                  alignment={"center"}
                />
                <Column
                  dataField="otpVerifiedStatus"
                  caption="OTP Verify Status"
                  allowSearch={true}
                />
                <Column
                  dataField="clubbedStatus"
                  caption="Clubbing Status"
                  allowSearch={true}
                />

                <Column
                  dataField="assignedTime"
                  caption="Assigned Time"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="locationTime"
                  caption="On Location"
                  allowSearch={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="loadTime"
                  caption="Boarded"
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="unloadTime"
                  caption="Reached"
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />
                <Column
                  dataField="completedTime"
                  caption="Completed"
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DisplayDateTime24NorthFormat}
                />

                <Template
                  name="toolbarDataFilterTemplate"
                  render={() => {
                    return (
                      <>
                        <span>
                          <i className={`fas fa-clock`}></i>{" "}
                          {this.state.reservationTitle}
                          <span className="ml-2">
                            [{" "}
                            {moment(this.state.filterFromDatetime).format(
                              `DD/MM/yyyy HH:mm`
                            )}
                            {" - "}
                            {moment(this.state.filterToDatetime).format(
                              `DD/MM/yyyy HH:mm`
                            )}{" "}
                            ]
                          </span>
                        </span>
                      </>
                    );
                  }}
                />
                <Template
                  name="toolbarDataDutyTypeDropdownTemplate"
                  render={() => {
                    return (
                      <>
                        <SelectBox
                          dataSource={DutyTypeLst}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Select duty type"
                          name="dutyTypeDropdown"
                          defaultValue={0}
                          value={this.state.dutyTypeId}
                          displayExpr="name"
                          valueExpr="id"
                          onValueChanged={(e) => {
                            try {
                              let dutyTypeId = e.value ?? 0;
                              this.setState((prev) => ({
                                ...prev,
                                dutyTypeId: dutyTypeId,
                              }));
                              this.filterTripDataGridDutyTypeWise(
                                dutyTypeId,
                                this.state.tripLst
                              );
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                          showClearButton={true}
                          searchEnabled={true}
                        />
                      </>
                    );
                  }}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={10} />
                <Pager
                  displayMode="compact"
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="CrewActivity"
                />
              </DataGrid>
            )}
          </div>
        </div>
        {this.state.locateVehicleMap.openModal && (
          <LocateVehicleComponent
            rideId={this.state.locateVehicleMap.rideId}
            vehicleNo={this.state.locateVehicleMap.vehicleNo}
            onClose={() => {
              this.setState((prev) => ({
                ...prev,
                locateVehicleMap: {
                  openModal: false,
                  rideId: 0,
                  vehicleNo: "",
                },
              }));
            }}
          />
        )}
        {this.state.replayVehicleMap.openModal && (
          <ReplayVehicleComponent
            rideId={this.state.replayVehicleMap.rideId}
            vehicleId={this.state.replayVehicleMap.vehicleId}
            vehicleNo={this.state.replayVehicleMap.vehicleNo}
            locationTime={this.state.replayVehicleMap.locationTime}
            completedTime={this.state.replayVehicleMap.completedTime}
            onClose={() => {
              this.setState((prev) => ({
                ...prev,
                replayVehicleMap: {
                  openModal: false,
                  rideId: 0,
                  vehicleId: 0,
                  vehicleNo: "",
                  locationTime: "",
                  completedTime: "",
                },
              }));
            }}
          />
        )}

        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={{ of: "#historydiv" }}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
